module.exports = __webpack_public_path__ + "static/media/Mary Wardell Headshot_1733439613395.4d625e30.jpeg";